import { ETypDatMatky } from 'enums/lei/leiDataEnums';

export const leiKonsolidaceSouborySelect = [
    {
        labelcz: 'ACCOUNTS_FILING',
        value: ETypDatMatky.ACCOUNTS_FILING
    },
    {
        labelcz: 'REGULATORY_FILING',
        value: ETypDatMatky.REGULATORY_FILING
    },
    {
        labelcz: 'SUPPORTING_DOCUMENTS',
        value: ETypDatMatky.SUPPORTING_DOCUMENTS
    },
    {
        labelcz: 'CONTRACTS',
        value: ETypDatMatky.CONTRACTS
    },
    {
        labelcz: 'OTHER_OFFICIAL_DOCUMENTS',
        value: ETypDatMatky.OTHER_OFFICIAL_DOCUMENTS
    }
];
